export default "__VITE_ASSET__mwjwCD7x__"